import React, {Component} from "react"

import {Team} from "@irati/types"

import TeamList from "../../../components/Teams/TeamList"
import TeamUserList from "../TeamUserList/TeamUserList"

interface Props {
  teams: Team[]
  setCurrentTeam: (currentTeam: Team | null) => void
  currentTeam: Team | null
}

interface State {
  isCreateTeamModalOpen: boolean
  currentTeam: boolean
  maxPage: boolean
}

class Teams extends Component<Props, State> {
  static defaultProps = {
    currentTeam: null
  }

  state: State = {
    isCreateTeamModalOpen: false,
    currentTeam: false,
    maxPage: false
  }

  render() {
    const {setCurrentTeam, teams, currentTeam} = this.props

    return (
      <>
        {currentTeam ? (
          <TeamUserList goBack={() => setCurrentTeam(null)} team={currentTeam} />
        ) : (
          <TeamList teams={teams} setCurrentTeam={setCurrentTeam} />
        )}
      </>
    )
  }
}

export default Teams
